import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import VConsole from 'vconsole'
import store from '@/store'

import {
  getUserInfoSuccess,
  getAppVerInfoSuccess,
} from "@/assets/js/client"

import './assets/styles/global.scss'

Vue.config.productionTip = false
// const vConsole = new VConsole();
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// 挂载方法到window对象
window.getUserInfoSuccess = getUserInfoSuccess
window.getAppVerInfoSuccess = getAppVerInfoSuccess